export const API_URL = "https://parseapi.back4app.com";
export const PARSE_APPLICATION_ID = "VqIbpuRJ7gqgb7NkxZ8mUwzlhpqE0EZRDchIZDoq";
export const PARSE_REST_API_KEY = "UbzdU1JlN3hJlwuNdTrZoKeIi6Jxoom7reTVi4Y0";
